import React, { useRef } from 'react';
import { basePageWrap } from '../BasePage';
import s from './LandingPage.module.scss';
import HeroBackground from '../../components/HeroBackground/HeroBackground';
import StreamField from '../../components/StreamField/StreamField';
import HeroImageLink from '../../components/HeroImageLink/HeroImageLink';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';

const LandingPage = ({ hero, contentBlocks, breadcrumbs }) => {
  const streamFieldRef = useRef(null);

  return (
    <div className={s.Root}>
      <div className={s.HeroWrapper}>
        <HeroBackground />
        {breadcrumbs && <Breadcrumb {...breadcrumbs} />}
        <HeroImageLink {...hero} scrollTargetRef={streamFieldRef} />
      </div>
      <div ref={streamFieldRef} className={s.StreamField}>
        <StreamField items={contentBlocks} modifiers={['LandingPage']} />
      </div>
    </div>
  );
};

export default basePageWrap(LandingPage);
